import React from 'react';
import moment from 'moment';
import './PatientSearchResult.css';

const PatientSearchResult = ({ 
  searchPatientList, 
  addAppObject, 
  setAddAppObject, 
  handleAddAppointment,
  handlePatientSelect
}) => {
  if (!searchPatientList || searchPatientList.length === 0) {
    return null;
  }

  return (
    <div className="patientSearchResults">
      <h3 className="resultsTitle">Found Profiles ({searchPatientList.length})</h3>
      <div className="resultsList">
        {searchPatientList.map((item, index) => {
          const onSelectPatient = handlePatientSelect || handleAddAppointment;
          const isNational = !item?.is_local;
          const isLocal = item?.is_local;
          const communeName = item?.municipality_name || item?.commune || item?.municipality || '';
          const wilayaName = item?.city_name || item?.wilaya || '';
          const apptCount = Number(item?.appointment_count_with_doctor ?? item?.previous_appointments_count ?? 0);
          const alreadyVisited = item?.already_visited == true || item?.already_visited === 1
            || item?.is_my_patient == true
            || apptCount > 0;

          const rawId = item?.id_number || '';
          const rawPhone = item?.cell_phone || '';

          const maskedId = isNational && rawId.length >= 6
            ? `${rawId.substring(0, 4)}${'*'.repeat(Math.max(0, rawId.length - 6))}${rawId.substring(rawId.length - 2)}`
            : rawId;

          return (
            <div 
              className={`patientCard ${isNational ? 'national' : 'local'}${alreadyVisited ? ' visited' : ''}`}
              key={index}
              onClick={() => onSelectPatient?.("found", item)}
            >
              {alreadyVisited && <span className="typeBadge">✔ Déjà venu(e)</span>}
              <div className="patientCardContent">
                {/* Row 1: Name */}
                <div className="patientCardHeader">
                  <div className="patientCardHeaderLeft">
                    <span className="patientName">
                      {item?.first_name} {item?.last_name}
                    </span>
                    {item?.age && <span className="patientAge">({item.age}y)</span>}
                    {item?.gender && (
                      <span className={`genderBadge ${item.gender?.toLowerCase() === 'male' ? 'male' : 'female'}`}>
                        {item.gender?.toLowerCase() === 'male' ? '♂' : '♀'}
                      </span>
                    )}
                  </div>
                </div>

                {/* Row 2: DOB & City */}
                <div className="patientCardDetails">
                  {item?.dob && <span>🎂 {moment(item.dob).format("DD/MM/YYYY")}</span>}
                  {(communeName || wilayaName) && <span>🌐 {communeName || wilayaName}</span>}
                </div>

                {/* Row 3: ID & Phone */}
                <div className="patientCardContact">
                  {maskedId && <span>🪪 {maskedId}</span>}
                  {rawPhone && <span>📞 {rawPhone}</span>}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PatientSearchResult;
